import {
  CHARCOAL_5,
  OwnUpExtraSmallHeadlineMedium,
  OwnUpThemeProvider,
  ownUpWhiteTheme,
  PropsWithTheme
} from '@rategravity/own-up-component-library';
import React from 'react';
import styled from 'styled-components';
import { useMonthlyPayment } from '../data/dataProvider';
import { MonthlyPaymentChartLegend } from './ChartLegend';
import { MonthlyPayment } from './MonthlyPayment';
import { MonthlyPaymentPieChart } from './PieChart';

const Container = styled.div`
  background-color: ${({ theme }: PropsWithTheme<{}>) => theme.palette.background.default};
  filter: drop-shadow(4px 4px 8px ${CHARCOAL_5});
  border-radius: ${({ theme }: PropsWithTheme<{}>) => theme.spacing(1, 1, 0, 0)};
  padding: ${({ theme }: PropsWithTheme<{}>) => theme.spacing(3, 3)};
  margin-top: ${({ theme }: PropsWithTheme<{}>) => theme.spacing(3)}px;
`;

const ChartWithLegendWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-top: ${({ theme }: PropsWithTheme<{}>) => theme.spacing(4)}px;
  ${({ theme }: PropsWithTheme<{}>) => theme.breakpoints.down('md')} {
    flex-direction: column;
  }
`;
const ChartWrapper = styled.div`
  flex: 1;
  ${({ theme }: PropsWithTheme<{}>) => theme.breakpoints.down('md')} {
    margin-bottom: ${({ theme }: PropsWithTheme<{}>) => theme.spacing(4)}px;
  }
`;
const LegendWrapper = styled.div`
  flex: 1;
  ${({ theme }: PropsWithTheme<{}>) => theme.breakpoints.down('md')} {
    align-self: flex-start;
  }
`;

export const CalculationSummary = () => {
  const {
    state: { showFull, homeownersInsuranceMonthly, hoaFeesMonthly },
    getMonthlyPayment,
    getMonthlyPrincipalAndInterest,
    getPropertyTaxesMonthly
  } = useMonthlyPayment();
  return (
    <>
      {showFull && (
        <OwnUpThemeProvider theme={ownUpWhiteTheme}>
          <OwnUpExtraSmallHeadlineMedium variant="h2">Your results</OwnUpExtraSmallHeadlineMedium>
          <Container>
            <MonthlyPayment />
            <ChartWithLegendWrapper>
              <ChartWrapper>
                <MonthlyPaymentPieChart
                  monthlyPayment={getMonthlyPayment()}
                  principalAndInterest={getMonthlyPrincipalAndInterest()}
                  propertyTaxes={getPropertyTaxesMonthly()}
                  homeownersInsurance={homeownersInsuranceMonthly}
                  hoaFeesMonthly={hoaFeesMonthly}
                />
              </ChartWrapper>
              <LegendWrapper>
                <MonthlyPaymentChartLegend
                  principalAndInterest={getMonthlyPrincipalAndInterest()}
                  propertyTaxes={getPropertyTaxesMonthly()}
                  homeownersInsurance={homeownersInsuranceMonthly}
                  hoaFeesMonthly={hoaFeesMonthly}
                />
              </LegendWrapper>
            </ChartWithLegendWrapper>
          </Container>
        </OwnUpThemeProvider>
      )}
    </>
  );
};
